import {ReferenceRequestVo} from '../../common/shared/api/karina/vo/ReferenceRequestVo.interface';

export function createDataKey(referenceRequestVo: ReferenceRequestVo): string {
  return JSON.stringify(referenceRequestVo);
}

export function createReferenceRequestVo(dataKey: string): ReferenceRequestVo {
  return JSON.parse(dataKey);
}
